import React from 'react';
import './MyApplications.css';
import ApplicationStatusCards from '../../components/JobCard/ApplicationStatusCards';
import { Typography } from '@mui/material';

const MyApplications: React.FC = () => {
  return (
    <div className="my-applications">
      <Typography variant="h4" fontWeight="bold" sx={{marginBottom: '2rem', marginTop: '2rem' }}>My Applications</Typography>
      <ApplicationStatusCards />
    </div>
  );
};

export default MyApplications;
